/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { ContentsProps, ContentsDefaults } from './contents';
import { PeriodsProps, PeriodsDefaults } from './periods';
import { NoFeeDaysProps, NoFeeDaysDefaults } from './noFeeDay';

export const FacilityProps = PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    agency: PropTypes.string,
    lat_long: PropTypes.shape({
        lat: PropTypes.string,
        long: PropTypes.string,
    }),
    state: PropTypes.string,
    blackout_periods: PeriodsProps,
    no_fee_periods: NoFeeDaysProps,
    contents: ContentsProps,
    is_upgradable: PropTypes.bool,
    is_external_search_disabled: PropTypes.bool,
});

export const FacilityDefaults = {
    id: null,
    name: '',
    agency: '',
    lat_long: {
        lat: '0',
        long: '0',
    },
    state: '',
    blackout_periods: PeriodsDefaults,
    no_fee_periods: NoFeeDaysDefaults,
    contents: ContentsDefaults,
    is_upgradable: false,
};
